import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetManagement,AssetSourceConfigurationItem } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from 'src/app/shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../../asset-management-api-endpoints';


@Injectable({
  providedIn: 'root'
})
export class AssetsViewService {
  private readonly assetsViewUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }


   FetchSystemAssetsView(
      currentPage: number
    ): Observable<AssetManagement[]> {
      return this.http
        .post<AssetManagement[]>(
          `${this.assetsViewUrl}${API_ENDPOINTS.ASSETVIEW.FETCH_SYSTEM_ASSETS_VIEW}`,
          { currentPage }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }
  
    FetchSystemAssetsViewSearch(
      currentPage: number,
      searchText: String,
      filterByHeader: String
    ): Observable<AssetManagement[]> {
      return this.http
        .post<AssetManagement[]>(
          `${this.assetsViewUrl}${API_ENDPOINTS.ASSETVIEW.FETCH_SYSTEM_ASSETS_VIEW_SEARCH}`,
          { currentPage, searchText, filterByHeader }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }


    FetchDataAssetsView(
    
      currentPage: number
    ): Observable<AssetManagement[]> {
      return this.http
        .post<AssetManagement[]>(
          `${this.assetsViewUrl}${API_ENDPOINTS.ASSETVIEW.FETCH_DATA_ASSETS_VIEW}`,
          {  currentPage }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }
  
    FetchDataAssetsViewSearch(
      currentPage: number,
      searchText: String,
      filterByHeader: String
    ): Observable<AssetManagement[]> {
      return this.http
        .post<AssetManagement[]>(
          `${this.assetsViewUrl}${API_ENDPOINTS.ASSETVIEW.FETCH_DATA_ASSETS_VIEW_SEARCH}`,
          { currentPage, searchText, filterByHeader }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }
  
    VerifySystemAssets() {
      return this.http
        .post<AssetManagement>(
          `${this.assetsViewUrl}${API_ENDPOINTS.ASSETVIEW.VERIFY_SYSTEM_ASSETS}`,
          { }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }
  
    FetchSystemAssetsVerificationView(currentPage: number): Observable<AssetManagement[]> {
      return this.http
        .post<AssetManagement[]>(
          `${this.assetsViewUrl}${API_ENDPOINTS.ASSETVIEW.FETCH_SYSTEM_ASSETS_VERIFICATION_VIEW}`,
          { currentPage }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }

    FetchSystemAssetsVerificationViewSearch(
      currentPage: number,
      searchText: String,
      filterByHeader: String
    ): Observable<AssetManagement[]> {
      return this.http
        .post<AssetManagement[]>(
          `${this.assetsViewUrl}${API_ENDPOINTS.ASSETVIEW.FETCH_SYSTEM_ASSETS_VERIFICATION_VIEW_SEARCH}`,
          { currentPage, searchText, filterByHeader }
        )
        .pipe(
          map((response) => response),
          catchError((error) => this.errorHandlingService.handleError(error))
        );
    }


    updateManualSystemAsset(
      systemAssetId: string,
      systemAssetDescription: string,
      systemAssetOwner: string,
      systemAssetStatus: string,
      systemAssetEndpoint: string,
      systemAssetLifecycleStatus: string,
      systemAssetBusinessValue: string,
      dataClassification: string,
      importedBy: string,
      importedByKeycloakId: string
    ): Observable<AssetManagement> {
      return this.http.post<AssetManagement>(
        `${this.assetsViewUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_MANUAL_SYSTEM_ASSET}`,
        {
          systemAssetId,
          systemAssetDescription,
          systemAssetOwner,
          systemAssetStatus,
          systemAssetEndpoint,
          systemAssetLifecycleStatus,
          systemAssetBusinessValue,
          dataClassification,
          importedBy,
          importedByKeycloakId
        }
      ).pipe(
        catchError(error =>
          this.errorHandlingService.handleError(error)
        )
      );
    }

    getManualSystemAsset(systemAssetId: string): Observable<AssetManagement> {
      return this.http.post<AssetManagement>(
        `${this.assetsViewUrl}${API_ENDPOINTS.ASSETCAPTURE.GET_MANUAL_SYSTEM_ASSET}`,
        {
          systemAssetId
        }
      ).pipe(
        catchError(error =>
          this.errorHandlingService.handleError(error)
        )
      );
    }

      deleteManualSystemAsset(systemAssetId: string): Observable<AssetManagement> {
      return this.http.post<AssetManagement>(
        `${this.assetsViewUrl}${API_ENDPOINTS.ASSETCAPTURE.DELETE_MANUAL_SYSTEM_ASSET}`,
        {
          systemAssetId
        }
      ).pipe(
        catchError(error =>
          this.errorHandlingService.handleError(error)
        )
      );
    }



  updateManualDataAsset(
    dataAssetId: string,
    organizationId: string,
    name: string,
    description: string,
    status: string,
    assetTechnicalName: string,
    qualifiedName: string,
    creationTimestamp: string,
    createdBy: string,
    lastModifiedTimestamp: string,
    lastModifiedBy: string,
    entityVersion: string,
    entityStatus: string,
    collectionId: string,
    classificationName: string,
    upstreamAssetRelationships: string,
    importedAt: string,
    uniqueIdentifier: string,
    importedBy: string,
    importedByKeycloakId: string
    ): Observable<AssetManagement> {
      return this.http.post<AssetManagement>(
        `${this.assetsViewUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_MANUAL_DATA_ASSET}`,
        {
          dataAssetId,
        organizationId,
        name,
        description,
        status,
        assetTechnicalName,
        qualifiedName,
        creationTimestamp,
        createdBy,
        lastModifiedTimestamp,
        lastModifiedBy,
        entityVersion,
        entityStatus,
        collectionId,
        classificationName,
        upstreamAssetRelationships,
        importedAt,
        uniqueIdentifier,
        importedBy,
        importedByKeycloakId
        }
      ).pipe(
        catchError(error =>
          this.errorHandlingService.handleError(error)
        )
      );
    }

  getManualDataAsset(dataAssetId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.assetsViewUrl}${API_ENDPOINTS.ASSETCAPTURE.GET_MANUAL_DATA_ASSET}`,
      {
        dataAssetId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }


    deleteManualDataAsset(dataAssetId: string): Observable<AssetManagement> {
      return this.http.post<AssetManagement>(
        `${this.assetsViewUrl}${API_ENDPOINTS.ASSETCAPTURE.DELETE_MANUAL_DATA_ASSET}`,
        {
          dataAssetId
        }
      ).pipe(
        catchError(error =>
          this.errorHandlingService.handleError(error)
        )
      );
    }
} 